import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProficiencyInWritingFormComponent } from "./proficiency-in-writing-form/proficiency-in-writing-form.component";
import { ProficiencyInWritingListComponent } from "./proficiency-in-writing-list/proficiency-in-writing-list.component";

@NgModule({
  declarations: [ProficiencyInWritingFormComponent, ProficiencyInWritingListComponent],
  imports: [CommonModule],
})
export class ProficiencyInWritingModule {}
